import React, { useRef, useEffect, ReactNode } from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css'

export type ScrollbarOptions = {
  children: ReactNode
  suppressScrollX?: boolean
  suppressScrollY?: boolean
}

export function WithScroller({ children, suppressScrollY }: ScrollbarOptions) {
  const psRef = useRef<PerfectScrollbar | null>(null)

  useEffect(() => {
    if (psRef.current) {
      psRef.current.updateScroll()
    }
  }, [children])

  return process.env.NODE_ENV !== 'test' ? (
    <PerfectScrollbar ref={psRef} options={{ suppressScrollY }}>
      {children}
    </PerfectScrollbar>
  ) : (
    children
  )
}

export default WithScroller
